/* eslint-disable */

/** unique or primary key constraints on table "argo.schedule_mode" */
export enum ArgoScheduleModeConstraint {
  /** unique or primary key constraint on columns "mode" */
  ScheduleModePkey = 'schedule_mode_pkey'
}

export enum ArgoScheduleModeEnum {
  /** covers two weeks of time */
  Biweekly = 'biweekly',
  /** covers one week of time */
  Weekly = 'weekly'
}

/** select columns of table "argo.schedule_mode" */
export enum ArgoScheduleModeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Mode = 'mode'
}

/** update columns of table "argo.schedule_mode" */
export enum ArgoScheduleModeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Mode = 'mode'
}

